import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar arquivos de tradução
import enTranslation from './locales/en/translation.json';
import ptTranslation from './locales/pt/translation.json';
import enNotifications from './locales/en/notifications.json';
import ptNotifications from './locales/pt/notifications.json';
import enBannerRenewSubs from './locales/en/banner_renew_subs.json';
import ptBannerRenewSubs from './locales/pt/banner_renew_subs.json';
import enNewSectionHomePage from './locales/en/new_section_home_page.json';
import ptNewSectionHomePage from './locales/pt/new_section_home_page.json';
import enMercadoPago from './locales/en/mercadopago.json';
import ptMercadoPago from './locales/pt/mercadopago.json';
import enSubscriptionRenewal from './locales/en/subscription_renewal.json';
import ptSubscriptionRenewal from './locales/pt/subscription_renewal.json';
import enStrategyPerformance from './locales/en/strategy_performance.json';
import ptStrategyPerformance from './locales/pt/strategy_performance.json';
import enFaqPage from './locales/en/faq_page.json';
import ptFaqPage from './locales/pt/faq_page.json';
import enGuidePage from './locales/en/guide_page.json';
import ptGuidePage from './locales/pt/guide_page.json';
import enOnboardingBanner from './locales/en/onboarding_banner.json';
import ptOnboardingBanner from './locales/pt/onboarding_banner.json';
import enTransferModal from './locales/en/transfer_modal.json';
import ptTransferModal from './locales/pt/transfer_modal.json';
import enReportsPage from './locales/en/reports_page.json';
import ptReportsPage from './locales/pt/reports_page.json';
import enHeader from './locales/en/header.json';
import ptHeader from './locales/pt/header.json';

import enBitcoinPage from './locales/en/bitcoin_page.json';
import ptBitcoinPage from './locales/pt/bitcoin_page.json';
import enDashboardPage from './locales/en/dashboard_page.json';
import ptDashboardPage from './locales/pt/dashboard_page.json';
import enPortfolioPage from './locales/en/portfolio_page.json';
import ptPortfolioPage from './locales/pt/portfolio_page.json';
import enWeeklyTradePage from './locales/en/weekly_trade_page.json';
import ptWeeklyTradePage from './locales/pt/weekly_trade_page.json';
import enModernHero from './locales/en/modern_hero.json';
import ptModernHero from './locales/pt/modern_hero.json';
import enConsultoria from './locales/en/consultoria.json';
import ptConsultoria from './locales/pt/consultoria.json';
import enInsufficientFunds from './locales/en/insufficient_funds.json';
import ptInsufficientFunds from './locales/pt/insufficient_funds.json';

// Mesclar traduções principais com notificações
const mergeDeep = (target, source) => {
  for (const key in source) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      if (!target[key]) target[key] = {};
      mergeDeep(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  }
  return target;
};

const resources = {
  en: {
    translation: mergeDeep(
      mergeDeep(
        mergeDeep(
          mergeDeep(
            mergeDeep(
              mergeDeep({ ...enTranslation }, enNotifications),
              enBannerRenewSubs
            ),
            enNewSectionHomePage
          ),
          enMercadoPago
        ),
        enSubscriptionRenewal
      ),
      enStrategyPerformance
    ),
    faqPage: enFaqPage,
    guidePage: enGuidePage,
    onboardingBanner: enOnboardingBanner,
    transfer_modal: enTransferModal,
    reports_page: enReportsPage,
    header: enHeader,

    bitcoinPage: enBitcoinPage,
    dashboardPage: enDashboardPage,
    portfolioPage: enPortfolioPage,
    weeklyTradePage: enWeeklyTradePage,
    modernHero: enModernHero,
    consultoria: enConsultoria,
    insufficientFunds: enInsufficientFunds
  },
  pt: {
    translation: mergeDeep(
      mergeDeep(
        mergeDeep(
          mergeDeep(
            mergeDeep(
              mergeDeep({ ...ptTranslation }, ptNotifications),
              ptBannerRenewSubs
            ),
            ptNewSectionHomePage
          ),
          ptMercadoPago
        ),
        ptSubscriptionRenewal
      ),
      ptStrategyPerformance
    ),
    faqPage: ptFaqPage,
    guidePage: ptGuidePage,
    onboardingBanner: ptOnboardingBanner,
    transfer_modal: ptTransferModal,
    reports_page: ptReportsPage,
    header: ptHeader,

    bitcoinPage: ptBitcoinPage,
    dashboardPage: ptDashboardPage,
    portfolioPage: ptPortfolioPage,
    weeklyTradePage: ptWeeklyTradePage,
    modernHero: ptModernHero,
    consultoria: ptConsultoria,
    insufficientFunds: ptInsufficientFunds
  }
};

// Função para forçar português brasileiro como idioma padrão
const initializeBrazilianPortuguese = () => {
  // 🇧🇷 FOCO 100% NO PÚBLICO BRASILEIRO
  // Sempre forçar português, independente de configurações anteriores
  localStorage.setItem('i18nextLng', 'pt');
  console.log('🇧🇷 Idioma configurado: Português (Brasil) - Público 100% brasileiro');
};

// Executar antes da inicialização do i18n
initializeBrazilianPortuguese();

// Inicializar i18n de forma síncrona
i18n
  // Detecta idioma do navegador
  .use(LanguageDetector)
  // Passa a instância i18n para react-i18next
  .use(initReactI18next)
  // Inicializa i18next
  .init({
    resources,
    
    // 🇧🇷 FOCO NO PÚBLICO BRASILEIRO: Português como idioma padrão e fallback
    fallbackLng: 'pt', // Português brasileiro como padrão
    
    // Idiomas suportados (português em primeiro para público brasileiro)
    supportedLngs: ['pt', 'en'],
    
    // Configurações de detecção - prioriza localStorage com português
    detection: {
      // Ordem de detecção: localStorage primeiro (sempre será 'pt')
      order: ['localStorage'],
      
      // Cache no localStorage
      caches: ['localStorage'],
      
      // Chave para salvar no localStorage
      lookupLocalStorage: 'i18nextLng',
      
      // Verificar se o idioma está na lista de suportados
      checkWhitelist: true,
    },

    interpolation: {
      // React já escapa por padrão
      escapeValue: false,
    },

    // Configurações de debug (desabilitar em produção)
    debug: false,
    
    // Configurações para React
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    },
    
    // Inicialização síncrona para evitar problemas de contexto
    initImmediate: false,
  });

export default i18n; 